var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33335 2.66667C5.33335 2.66667 2.66669 6.66667 2.66669 10.6667C2.66669 13.48 4.00002 17.3333 5.33335 18.6667C6.66669 20 8.00002 29.3333 10.6667 29.3333C16.72 29.3333 13.3334 20 16 20C18.6667 20 15.28 29.3333 21.3334 29.3333C24 29.3333 25.3334 20 26.6667 18.6667C28 17.3333 29.3334 13.48 29.3334 10.6667C29.3334 6.66667 26.6667 2.66667 22.6667 2.66667C18.6667 2.66667 18.6667 4 16 4C13.3334 4 13.3334 2.66667 9.33335 2.66667ZM9.33335 5.33333C12 5.33333 13.3334 6.66667 16 6.66667C18.6667 6.66667 20 5.33333 22.6667 5.33333C24.8934 5.33333 26.6667 8 26.6667 10.6667C26.6667 13 25.52 16.1467 24.2534 17.4133C23.1067 18.56 21.4134 26.5867 20.6667 26.5867C20.3867 26.5867 20 25.1733 20 23.4533C20 20.7333 19.24 17.3333 16 17.3333C12.76 17.3333 12 20.7333 12 23.4533C12 25.1733 11.6134 26.5867 11.3334 26.5867C10.5867 26.5867 8.89335 18.56 7.74669 17.4133C6.48002 16.1467 5.33335 13 5.33335 10.6667C5.33335 8 7.10669 5.33333 9.33335 5.33333Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#027bff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooth);
export default __webpack_public_path__ + "static/media/Tooth.6ead97278f4147716c8f85f25ac3f1cf.svg";
export { ForwardRef as ReactComponent };